import gql from 'graphql-tag';

export default gql`
  fragment preleadProjectGroupCustomizeItemTextFragment on PreleadProjectGroupCustomizeItemText {
    id
    value
    projectGroupPreleadCustomizeItemId
  }
`;
